export default __webpack_public_path__ + "locales/pt-BR/Ldap.json?hash=fa250c68da7dbc87fcc87c85e5f7ff8d";